import { render, staticRenderFns } from "./EditExtensionModal.vue?vue&type=template&id=42ddefd0&"
import script from "./EditExtensionModal.vue?vue&type=script&lang=js&"
export * from "./EditExtensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports